module.exports = __webpack_public_path__ + "img/Icon-ionic-md-mail.0a395584.svg";